exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reset-form{position:relative}@media(min-width: 1160px){.reset-form{height:322px}}.reset-form__back-button{position:absolute;top:-50px;left:0;width:40px;height:40px;padding:8px;background-color:#f3f3f3;border:none;border-radius:50%;border:none;overflow:hidden;-webkit-transition:all ease .2s;-o-transition:all ease .2s;transition:all ease .2s;cursor:pointer}@media(min-width: 1160px){.reset-form__back-button{top:-58px;width:48px;height:48px;padding:12px}.reset-form__back-button:hover{background-color:#f3dddd}}.reset-form__back-button svg{display:block}.reset-form__recaptcha{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;margin-top:24px;margin-bottom:32px}.reset-form__captcha{position:relative;display:block;width:237px;height:120px;margin:0 auto 24px;background-color:#f5f5f5}.reset-form__captcha::before{position:absolute;top:0;bottom:0;left:0;right:0;content:\"\";background-color:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/login-page/login/reset-password-form/style.scss
// module id = 1265
// module chunks = 58